var _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStorybg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 34,
    r: 32.1071,
    stroke: "url(#paint0_linear_9815_26037)",
    strokeWidth: 2.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.32 3.32"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9815_26037",
    x1: 71.0263,
    y1: 9.52632,
    x2: 2.5,
    y2: 51.1316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C5BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0C5BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#F46710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9B04"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybg);
export default __webpack_public_path__ + "static/media/storybg.e641ddbf9eda90dea50918b0a406ce8b.svg";
export { ForwardRef as ReactComponent };